mcWeb.payments = jQuery.extend(mcWeb.payments, new function () {

    this.vm = function (id) {
        
        // Se også LoginCheckoutView.js, subscribe(onShowHideLogin)
        var KCO_BETBETID = 167;
        var SVEA_PARTPAYMENT = 128;
        var ARVATO_PARTPAYMENT = 107;
        var ARVATO_BUSINESS = 95;
        var NETS_EASY_BETBETID = 183;
        var VIPPS_BETBETID = 186;
        var SCO_BETBETID = 187;

        this.netsEasyCheckout = null;
        this.netsEasyCheckoutHtml = null;
        this.betBetIdList = "";

        var $ = jQuery;
        var self = this;
        this.id = "#" + id;
        this.settings = null;
        self.isBound = false;
        self.isPublishMode = false;
        var publishModeBody = $("body.publish-mode");
        if (publishModeBody !== undefined && publishModeBody !== null && publishModeBody.length > 0)
            self.isPublishMode = true;

        self.kcoValidateCountry = true;

        self.netsEasyCheckoutUrl = "";
        self.netsEasyProduction = false;
        self.netsEasyEnabled = false;
        self.cartName = null;
        self.cartGuid = null;
        self.service = new WebApiService("Payment");
        self.waitCheckoutSnippet = false;
        self.langService = new LanguageService();
        self.conditionsVM = null;
        self.cancelEnter = function () {
            if (event.keyCode === 13) {
                event.preventDefault();
            } else return true;
        };

        this.load = function (data, settings, isPaymentChange) {
            if (settings !== null && settings) {
                self.settings = settings;
            }

            getLibrary("mcWeb.customerRegistration").then(() => {
                if (mcWeb.customerRegistration.instances === undefined || mcWeb.customerRegistration.instances["checkout-registration"] === undefined) {
                    PubSub.subscribe(mcWeb.events.customerRegistration.onCustomerRegLoaded, function () {
                        self.registration = mcWeb.customerRegistration.instances['checkout-registration'];
                        self.innerLoad(data, settings, isPaymentChange);
                        
                    });
                }
                else {
                    self.registration = mcWeb.customerRegistration.instances['checkout-registration'];
                    self.innerLoad(data, settings, isPaymentChange);
                    
                }
               
            });
        }
        this.innerLoad = function (data, settings, isPaymentChange) {
            PubSub.publish(mcWeb.payments.events.onShowUpdateIcon, null);

           

            if (data === null || !data) {
                self.service.GetAction("GetPaymentList", null).then(function (result) {
                    self.innerLoad(result, null, isPaymentChange);
                });

                return;
            }

            self.Porterbuddy = self.settings.Porterbuddy;
            self.CustomerCountryId = self.settings.CustomerCountryId;

            self.klarnaShowCustomerTypeSelection(false);
            self.klarnaShippingAssistantEnabled(false);
            self.klarnaShowChangedCustomerTypeMessage(false);

            if (self.settings.Klarna) {
                self.klarnaShowCustomerTypeSelection(self.settings.Klarna.ShowCustomerTypeSelection);
                self.klarnaShippingAssistantEnabled(self.settings.Klarna.ShippingAssistantEnabled);
                self.klarnaShowChangedCustomerTypeMessage(self.settings.Klarna.ShowChangedCustomerTypeMessage);
            }

            self.sveaCheckoutShowCustomerTypeSelection(false);

            if (self.settings.SveaCheckout) {
                self.sveaCheckoutShowCustomerTypeSelection(self.settings.SveaCheckout.ShowCustomerTypeSelection);
            }

            self.vippsExpressCheckoutInCart(false);
            self.vippsShowCustomerTypeSelection(false);
            self.vippsAllowBusinessCustomer(false);

            if (self.settings.Vipps) {
                if (!self.isLoggedIn() && !self.registration.registrationVM.readOnly())
                    self.vippsExpressCheckoutInCart(self.settings.Vipps.ExpressCheckoutInCart);
                self.vippsShowCustomerTypeSelection(self.settings.Vipps.ShowCustomerTypeSelection);
                self.vippsAllowBusinessCustomer(self.settings.Vipps.AllowBusinessCustomer);
            }

            if (self.settings.NetsEasy) {
                self.netsEasyEnabled = self.settings.NetsEasy.Enabled;
                self.netsEasyProduction = self.settings.NetsEasy.Production;
                self.netsEasyShowCustomerTypeSelection(self.settings.NetsEasy.ShowCustomerTypeSelection);
                self.netsEasyCheckoutUrl = self.settings.NetsEasy.CheckoutUrl;
            }
            self.setNetsEasyCheckoutScriptSource();

            if (self.registration.registrationVM.readOnly() === true) {
                var experianRemoved = false;
                if (self.registration.registrationVM.hideExperianBetBet()) {

                    var expIndex = -1;
                    if (data.PaymentTypes !== null) {
                        for (var i = 0; i < data.PaymentTypes.length; i++) {
                            if (data.PaymentTypes[i].PaymentId === self.registration.registrationVM.experianBetBetId())
                                expIndex = i;
                        }
                    }

                    if (expIndex !== -1) {
                        data.PaymentTypes.splice(expIndex, 1);
                        experianRemoved = true;
                    }

                } else if (self.registration.registrationVM.hideOrgnrSsn()) {
                    self.ShowOrgnrSsn(false);
                    self.ShowOrgnrSsnField(0);
                }
            }

            // Vi sjekker om det er gjort endringer på betalingsmåter som skal vises 
            // og setter kun PaymentTypes dersom det er en endring. Dette for å hindre 
            // at hele paymentviewet unødvendig lastes på nytt. 
            if (self.PaymentTypes() && data.PaymentTypes && self.PaymentTypes().length == data.PaymentTypes.length) {
                for (var i = 0; i < data.PaymentTypes.length; i++) {
                    if (self.PaymentTypes()[i].PaymentId !== data.PaymentTypes[i].PaymentId) {
                        self.PaymentTypes(data.PaymentTypes);
                        break;
                    }
                }
            }
            else {
                self.PaymentTypes(data.PaymentTypes);
            }

            self.KlarnaCustomerType(data.CustomerType);
            self.CustomerType(data.CustomerType);

            self.addBindings();
            self.isLoggedIn(data.IsLoggedIn);
            self.BirthDate(data.BirthDate);

            var paymentMethodSelected = false;
            var hasKlarnaCheckout = false;
            let doLoadCustomerForm = false;
            if (data.PaymentTypes !== null) {
                for (var i = 0; i < data.PaymentTypes.length; i++) {

                    if (data.PaymentTypes[i].PaymentId === KCO_BETBETID) {
                        hasKlarnaCheckout = true;
                    }

                    if (data.PaymentTypes[i].PaymentId === NETS_EASY_BETBETID) {
                        hasKlarnaCheckout = true;
                    }

                    if (data.PaymentTypes[i].PaymentId === SCO_BETBETID) {
                        hasKlarnaCheckout = true;
                    }

                    if (experianRemoved === true) {
                        self.selectPaymentType(data.PaymentTypes[i]);
                        paymentMethodSelected = true;
                        experianRemoved = false;
                    }

                    if (data.PaymentTypes[i].PaymentId === data.SelectedId) {
                        self.selectPaymentType(data.PaymentTypes[i]);
                        doLoadCustomerForm = true;
                        //moved loadCustomerForm because we haven't applied the bindings yet
                        paymentMethodSelected = true;
                    }
                }
            }

            // Vi oppdaterer visningen av betalingsmåtene dersom listen over betalingsmåter er endret siden forrige visning
            if (data.PaymentList !== self.betBetIdList) {
                //console.log("Liste med BetBet er endret");
                self.betBetIdList = data.PaymentList;
                PubSub.publish(mcWeb.payments.events.reloadPayments, "reloadPayments");
            }

            if (paymentMethodSelected === false) {
                console.log('Advarsel: Ingen betalingsmåter er aktivert for denne kunden!');
            }
                PubSub.publish(mcWeb.payments.events.onHideUpdateIcon, null);

            if (!self.isBound) {
                self.showCustomerRegButtonPrivate = ko.computed(function () {
                    if (self.registration === undefined || self.registration.registrationVM === undefined)
                        return false;

                    return self.registration.registrationVM.customerType() === 'business' && !self.registration.registrationVM.readOnly() && !self.registration.registrationVM.isLoggedIn() && !self.registration.registrationVM.onlyBusiness();
                });

                self.showCustomerRegButtonBusiness = ko.computed(function () {
                    if (self.registration === undefined || self.registration.registrationVM === undefined)
                        return false;

                    return self.registration.registrationVM.customerType() === 'private' && !self.registration.registrationVM.readOnly() && !self.registration.registrationVM.isLoggedIn() && !self.registration.registrationVM.onlyPrivate();
                });

                let vmNode = document.getElementById(self.settings.VMID);
                ko.applyBindings(self, vmNode);
                self.isBound = true;//prevent multiple bindings of this VM
            }

            self.lockPorterbuddyRecipientInfo(data.SelectedId);

            if (doLoadCustomerForm) {
                self.loadCustomerForm(data.SelectedId, hasKlarnaCheckout, isPaymentChange);
            }
        };

        this.setNetsEasyCheckoutScriptSource = function () {
            if (!self.netsEasyEnabled) {
                $('#netseasy-checkout-script').hide();
                return;
            }

            $('#netseasy-checkout-script').show();
            $('#netseasy-checkout-script').attr("src", self.netsEasyCheckoutUrl);
        };

        this.highlightRequiredConditions = function () {
            if (self.conditionsVM)
                self.conditionsVM.highlightRequired("checkoutconditions");
        };

        this.addBindings = function () {
            $(document).on('shown.bs.tab', 'a[href="#97"]', function (e) {
            });
        };

        this.hasCartItems = ko.observable(false);
        this.functionalConditionsAccepted = ko.observable(true); //backwards compatibility
        this.showPayments = ko.computed(function () {
            return self.hasCartItems();
        }, this);
        this.PaymentTypes = ko.observableArray();

        this.selectedPaymentOld = ko.observable();
        this.selectedPayment = ko.observable();

        this.selectedPayment.subscribe(function (newValue) {
            if (self.selectedPaymentOld() !== newValue) {
                self.selectedPaymentOld(newValue);
                self.selectedPayment(newValue);
                PubSub.publish(mcWeb.payments.events.onSelectedPayment, newValue);
            }
        });

        this.KlarnaCampaigns = ko.observableArray();
        this.Fodselsnummer = ko.observable();
        this.RegisteredZip = ko.observable();
        this.BirthDate = ko.observable();
        this.BirthDate.subscribe(function (newValue) {
            if (newValue !== null && newValue.length > 0) {
                newValue = newValue.replace(/[^\d]/, '');
                self.BirthDate(newValue);

                //Test date: 011299 
                if (self.isValidDateddmmyy(newValue)) {
                    self.service.GetAction("UpdateBirthDate", { date: newValue }).then(function (result) {
                        var input = $('.col-birthdate .genericBirthdate');
                        var symbol = $('.col-birthdate i');

                        if (result === true) {
                            symbol.addClass('icon-check green');
                            input.removeClass('validation_error');
                        } else {
                            symbol.removeClass('icon-check green');
                            input.addClass('validation_error');
                        }
                    });
                }
            }
        });

        this.Orgnr = ko.observable();
        this.Orgnr.subscribe(function (data) {
            PubSub.publish(mcWeb.payments.events.updateOrgNr, data);
        });

        self.selectedSveaPaymentPlanOptionRadio = ko.observable();

        this.showSveaPaymentPlanOptionInfo = function (campaignCode) {
            if (self.selectedSveaPaymentPlanOptionRadio() == campaignCode)
                return true;
            return false;
        }

        this.formatMoney = function (money) {
            return money;
        };

        this.formatInterest = function (interest) {
            return interest + " %";
        };

        this.CustomerCountryId = 1;
        this.GothiaTOS = ko.observable();
        this.GothiaRequireCustomerConfirmation = ko.observable();
        this.AcceptedTermsAndConditions = ko.observable();
        this.ShowOrgnrSsn = ko.observable();
        this.ShowOrgnrSsnField = ko.observable();
        this.KlarnaCustomerType = ko.observable();
        this.CustomerType = ko.observable();
        this.showRefreshSpin = ko.observable(false);
        this.showRefreshSpinMargin = ko.observable(0);
        this.isLoggedIn = ko.observable(false);
        this.SveaWebPayPaymentPlanOptions = ko.observableArray();
        this.GetSveaWebPayPaymentPlanOptions = ko.observable();
        this.klarnaShowCustomerTypeSelection = ko.observable(false);
        this.klarnaShippingAssistantEnabled = ko.observable(false);
        this.klarnaShowChangedCustomerTypeMessage = ko.observable(false);
        this.vippsExpressCheckoutInCart = ko.observable(false);
        this.vippsShowCustomerTypeSelection = ko.observable(false);
        this.vippsAllowBusinessCustomer = ko.observable(false);
        this.sveaCheckoutShowCustomerTypeSelection = ko.observable(false);
        this.netsEasyShowCustomerTypeSelection = ko.observable(false);
        this.Porterbuddy = false;

        this.showCustomerSelection = function () {
            switch (self.selectedPayment()) {
                case 186:   //Vipps
                    return self.vippsExpressCheckoutInCart() && self.vippsShowCustomerTypeSelection();
                    break;
                case 167:   //KCO
                    return self.klarnaShowCustomerTypeSelection();
                    break;
                case 183:   //Easy
                    return self.netsEasyShowCustomerTypeSelection();
                    break;
            }
            return true;
        };

        //Set the hight of "update icon"
        this.showRefreshSpin.subscribe(function () {
            var hight = parseFloat($("#payments.payments").height());
            if (hight !== NaN && hight > 1) {
                hight = ((hight / 2) - 30);
                if (hight < 5)
                    hight = 5;
                self.showRefreshSpinMargin(hight + 'px');
            }
        });

        var hasCartItem = true;
        PubSub.subscribe(mcWeb.cart.events.hasCartItems, function (message, data) {
            if (data === false) {
                self.hasCartItems(false);
                hasCartItem = false;
            } else {
                hasCartItem = true;
            }

        });

        getLibrary("mcWeb.customerRegistration").then(() => {
            PubSub.subscribe(mcWeb.events.customerRegistration.onChangedCustomerData, function (message, data) {
                if (data !== null && data.isLoggedIn !== null) {
                    self.isLoggedIn(data.isLoggedIn);
                }
                if (hasCartItem === false)
                    self.hasCartItems(false);
                else
                    self.hasCartItems(true);

                self.RegisterKlarnaListener();
            });
        });

        PubSub.subscribe(mcWeb.conditions.events.onAcceptChange, function (evt, conditionStatus) {
            if (conditionStatus.usageArea === 3) {
                var previousFunctionalAcceptanceStatus = self.functionalConditionsAccepted();
                self.conditionsVM = conditionStatus.vm;
                if (conditionStatus.functionalConditionIsAccepted === null) {
                    self.functionalConditionsAccepted(true);
                } else if (conditionStatus.acceptDocuments === null || conditionStatus.acceptDocuments.length <= 0) {
                    self.functionalConditionsAccepted(true);
                }
                else {
                    self.functionalConditionsAccepted(conditionStatus.functionalConditionIsAccepted);
                }
                if (self.functionalConditionsAccepted()) {
                    if (self.selectedPayment() === KCO_BETBETID || self.selectedPayment() === NETS_EASY_BETBETID || self.selectedPayment() === SCO_BETBETID ||
                        (self.selectedPayment() === VIPPS_BETBETID && (!self.vippsAllowBusinessCustomer() || self.CustomerType() !== 'bedriftskunde'))) {
                        PubSub.publish(mcWeb.payments.events.onShowUpdateIcon, null);
                        if (previousFunctionalAcceptanceStatus !== self.functionalConditionsAccepted()) {
                            if (!self.KCOisLoaded()) {
                                self.KCOisLoaded(true);
                                self.loadCustomerForm(self.selectedPayment(), true);
                            } else {
                                self.processPaymentMethods(self.selectedPayment());
                            }
                            self.UpdateCheckoutCartItems();
                        }

                        if (self.selectedPayment() === VIPPS_BETBETID)
                            $('.payment-title').show();

                        PubSub.publish(mcWeb.payments.events.onHideUpdateIcon, null);

                    }
                } else {
                    if (self.selectedPayment() === KCO_BETBETID || self.selectedPayment() === NETS_EASY_BETBETID || self.selectedPayment() === SCO_BETBETID ||
                        (self.selectedPayment() === VIPPS_BETBETID && self.vippsExpressCheckoutInCart() && (!self.vippsAllowBusinessCustomer() || self.CustomerType() !== 'bedriftskunde'))) {
                        //if (previousFunctionalAcceptanceStatus != self.functionalConditionsAccepted())
                        self.highlightRequiredConditions();

                        if (self.selectedPayment() === VIPPS_BETBETID)
                            $('.payment-title').hide();
                    }
                    self.KCOisLoaded(false);
                }
            }
        });

        getLibrary("mcWeb.loginCheckout").then(() => {
            PubSub.subscribe(mcWeb.loginCheckout.events.onShowLoginPassword, function (message, paymentId) {
                self.ShowOrgnrSsn(false);
            });
        });

        this.loadCustomerForm = function (paymentId, hasKlarnaCheckout, isPaymentChange) {

            var el = $("#mcweb-customerregistration-checkout-registration");

            var tabContent = $(".tab-content");
            var tabHeight = tabContent.height();
            tabContent.css('min-height', tabHeight + 'px');
            var form = null;

            if (!self.isPublishMode) {//gaia windows fail when we attach/detach the 
                form = el.detach();
            }

            $('#payments-tab-nav a[href="#' + paymentId + '"]').tab('show');
            self.selectedPayment(paymentId);
            if (!self.isPublishMode) {
                form.appendTo("#" + paymentId);
            }

            $("#mcweb-customerregistration-checkout-registration").show();

            tabContent.animate({ "min-height": "250px" }, { queue: false, duration: 800 });

            var checkout = $('.checkout');
            var nav = $('#payments-tab-nav');

            if (hasKlarnaCheckout) {
                nav.show();
                checkout.removeClass('l-out').addClass('l-in');
            }

            if (self.isLoggedIn() || paymentId === KCO_BETBETID || paymentId === NETS_EASY_BETBETID || paymentId === SCO_BETBETID ||
                (paymentId === VIPPS_BETBETID && self.vippsExpressCheckoutInCart() && (!self.vippsAllowBusinessCustomer() || self.CustomerType() !== 'bedriftskunde'))) {

                if (paymentId === KCO_BETBETID || paymentId === NETS_EASY_BETBETID || paymentId === SCO_BETBETID ||
                    (paymentId === VIPPS_BETBETID && !self.isLoggedIn())) {
                    checkout.removeClass('l-in').addClass('l-out');
                    PubSub.publish(mcWeb.checkout.events.onShowSendOrder, { showBtn: false, disabledBtn: false, showPrice: false, showSalesConditions: false });
                } else {
                    checkout.removeClass('l-out').addClass('l-in');
                    PubSub.publish(mcWeb.checkout.events.onShowSendOrder, { showBtn: true, disabledBtn: false, showPrice: true, showSalesConditions: true });
                }

                nav.show();

                if (!self.functionalConditionsAccepted() && paymentId === VIPPS_BETBETID) {
                    $('.payment-title').hide();
                } else {
                    $('.payment-title').show();
                }

                $('.tab-content').removeClass('tab-radius');

                //if (paymentId === NETS_EASY_BETBETID && self.netsEasyCheckout !== undefined && self.netsEasyCheckout === null)
                self.processPaymentMethods(paymentId, isPaymentChange);

            } else {
                PubSub.publish(mcWeb.checkout.events.onShowSendOrder, { showBtn: true, disabledBtn: true, showPrice: true, showSalesConditions: true });

                checkout.removeClass('l-out').addClass('l-in');
                PubSub.publish(mcWeb.loginCheckout.events.onShowHideLogin, paymentId);
            }

            self.getGothiaAccountTos(paymentId);
            self.getSveaWebPayPaymentPlanOptions(paymentId);

            PubSub.publish(mcWeb.payments.events.onHideUpdateIcon, null);

            if (!!mcWeb.inlineEditor)
                mcWeb.inlineEditor.init(true);

            //}); //el.slideUp
        };

        this.KCOisLoaded = ko.observable(false);

        this.selectPaymentType = function (paymentType) {
            var data = { paymentId: paymentType.PaymentId, paymentText: paymentType.PaymentText };
            self.service.GetAction("SelectPayment", data).then(function (result) {
                PubSub.publish(mcWeb.cart.events.onChangedCart, null);
            });
        };

        this.handlePaymentChange = function (paymentType) {
            PubSub.publish(mcWeb.payments.events.onShowUpdateIcon, null);
            $('.qtip').qtip('destroy', true);

            // Vipps er ikke tilgjengelig for bedriftskunder
            if (paymentType.PaymentId === VIPPS_BETBETID && self.vippsExpressCheckoutInCart() && (!self.vippsAllowBusinessCustomer() || self.CustomerType() !== 'bedriftskunde'))
                self.clickPrivate();

            self.selectedPayment(paymentType.PaymentId);

            self.loadCustomerForm(paymentType.PaymentId, null, true);

            self.lockPorterbuddyRecipientInfo(paymentType.PaymentId);

            if (paymentType.PaymentId === KCO_BETBETID || paymentType.PaymentId === NETS_EASY_BETBETID || paymentType.PaymentId === SCO_BETBETID ||
                (paymentType.PaymentId === VIPPS_BETBETID && self.vippsExpressCheckoutInCart() && (!self.vippsAllowBusinessCustomer() || self.CustomerType() !== 'bedriftskunde'))) {
                self.KCOisLoaded(true);
                if (!self.functionalConditionsAccepted())
                    self.highlightRequiredConditions();
            }
            self.selectPaymentType(paymentType);//this will publish onChangedCart event, no need to publish an extra identical event            
        };

        this.lockPorterbuddyRecipientInfo = function (paymentId) {
            if (typeof porterbuddy !== 'undefined' && typeof porterbuddy.setRecipientInfoLocked === 'function') {
                if (paymentId === SCO_BETBETID || paymentId === KCO_BETBETID)
                    porterbuddy.setRecipientInfoLocked(true);
                else if (paymentId === NETS_EASY_BETBETID)
                    porterbuddy.setRecipientInfoLocked(false);
                else
                    porterbuddy.setRecipientInfoLocked(false);
            }
        };

        this.getJsonData = function () {
            var campaignCode = '';
            if (self.selectedPayment() === SVEA_PARTPAYMENT) campaignCode = self.selectedSveaPaymentPlanOptionRadio();

            var orgnrTemp = self.Orgnr();
            if (self.selectedPayment() === ARVATO_BUSINESS) {
                orgnrTemp = self.Fodselsnummer();
            }
            var birthdate = 'undefined';
            if (self.ShowOrgnrSsn()) {
                birthdate = self.BirthDate();
            }
            var paymentDetails = {
                SocialSecurityNumber: self.Fodselsnummer(),
                CampaignCode: campaignCode,
                AcceptCreditCheck: self.AcceptedTermsAndConditions(),
                OrgNumber: orgnrTemp,
                Birthdate: birthdate,
                RegisteredPostCode: self.RegisteredZip()
            };

            return {
                selectedPayment: self.selectedPayment(),
                paymentDetails: paymentDetails
            };
        };

        this.updatePaymentWithPBAddress = function (recipientInfo) {
            var paymentType = self.selectedPayment();

            if (!paymentType)
                return;

            var provider = "";
            switch (paymentType) {
                case KCO_BETBETID:
                    provider = "KlarnaCheckout";
                    break;
                case NETS_EASY_BETBETID:
                    provider = "NetsEasy";
                    break;
                case VIPPS_BETBETID:
                    provider = "Vipps";
                    break;
                case SCO_BETBETID:
                    provider = "Svea";
                    break;
            }

            var addressLine = recipientInfo.streetAddress;
            var zipCode = recipientInfo.postCode;
            var email = recipientInfo.email;
            var req = { Provider: provider, AddressLine: addressLine, ZipCode: zipCode, Email: email };

            self.service.PostAction("UpdatePorterbuddyDeliveryAddress", req).then(function (result) {
                if (result === null || result.length < 1) {
                    console.log("Oppdatering av adresse feilet");
                }
            });
        }

        this.validateSveaWebPay = function (payment) {
            var paymentId = payment.selectedPayment();
            var resName = "";
            var element;

            if (self.CustomerType() === 'bedriftskunde') {
                element = self.findClass(paymentId, "SveaWebPay_OrgNo", "input");
                if (!payment.isOrgnrValid($(".SveaWebPay_OrgNo"), false)) return { IsValid: false, ResName: "OrgnummerError", Element: element }
                else mcWeb.validation.setValidCss(element);
            } else {
                element = self.findClass(paymentId, "SveaWebPay_PersonalId", "input");
                if (!payment.isFodselsnummerValid($(".SveaWebPay_PersonalId"), false)) return { IsValid: false, ResName: "FodselsnummerError", Element: element }
                else mcWeb.validation.setValidCss(element);
            }

            if (paymentId === 128) {
                var radioButtonListArray = $("input[name='sveaPaymentPlanOptionRadio']");
                var checked = false;

                for (var i = 0; i < radioButtonListArray.length; i++) {
                    if (radioButtonListArray[i].checked)
                        checked = true;
                }

                if (!checked)
                    return { IsValid: false, ResName: "SveaPaymentPlanOptionNotSet", Element: radioButtonListArray[0] };
            }

            return { IsValid: true, ResName: resName, Element: element };
        };

        this.findClass = function (paymentId, cssClass, type) {
            try {
                var paymentDiv = $("div[id=" + paymentId + "]");
                var toFind = type + "[class*='" + cssClass + "']";
                var found = paymentDiv.find(toFind);
                return found;
            } catch (e) {
                return null;
            }
        };


        this.getSveaWebPayPaymentPlanOptions = function (paymentId) {
            if (paymentId === SVEA_PARTPAYMENT) {
                PubSub.publish(mcWeb.payments.events.onShowUpdateIcon, null);
                self.service.GetAction("GetSveaWebPayPaymentPlanOptions", null).then(function (result) {
                    PubSub.publish(mcWeb.payments.events.onHideUpdateIcon, null);
                    self.SveaWebPayPaymentPlanOptions(JSON.parse(result));
                });
            }
        };

        this.getGothiaAccountTos = function (paymentId) {
            if (paymentId === ARVATO_PARTPAYMENT) {
                PubSub.publish(mcWeb.payments.events.onShowUpdateIcon, null);
                self.service.GetAction("GetAccountTermsAndConditions", null).then(function (result) {
                    PubSub.publish(mcWeb.payments.events.onHideUpdateIcon, null);
                    self.GothiaTOS(result.TermsAndConditions);
                    self.GothiaRequireCustomerConfirmation(result.RequireCustomerConfirmation);
                });
            }
        };

        this.gothiaShowTermsAndConditions = function () {
            var generator = window.open('', 'gothiaTos', 'height=600,width=730,location=0,menubar=0');
            generator.document.write(self.GothiaTOS());
            generator.document.close();
        };

        this.getFakturaGebyr = function () {
            return self.service.GetAction("GetFakturaGebyr", null);
        };

        this.isFodselsnummerValid = function (element, klarna) {
            var regEx = null;

            if (self.CustomerCountryId === 1) //Norge
                regEx = /^[0-9]{2}[0,1][0-9][0-9]{2}[ ]?[0-9]{5}$/;
            else if (self.CustomerCountryId === 2) //Sverige
                regEx = /^([0-9]{2})?[0-9]{2}[0-1][0-9][0-9]{2}[-+]?[0-9]{4}$/;
            else if (self.CustomerCountryId === 3) //Danmark
                regEx = /^[0-9]{2}[0,1][0-9][0-9]{2}[0-9]{4}$/;
            else if (self.CustomerCountryId === 4) //Finland
                regEx = /^[0-9]{2}\.?[0,1][0-9]\.?[0-9]{2}[-+A][0-9]{3}[0-9A-Z]{1}$/;

            if (regEx === null) return true;
            return regEx.test(element.val());
        };

        this.isZipCodeValid = function (element) {
            if (element.val().length <= 0) return false;
            return true;
        };

        this.isZipCodeValidFormat = function (element, landId) {
            var zipCode = element.val();
            var regEx = /^\d{4}$/;
            if (zipCode.match(regEx) !== null)
                return true;
            return false;
        };

        this.isPhoneValidFormat = function (element, landId) {
            var phone = element.val();
            var regEx = /^\d{8}$/;
            if (phone.match(regEx) !== null)
                return true;
            return false;
        };

        this.isValidDateddmmyy = function (dateString) {
            var regEx = /\d{2}\d{2}\d{2}/;
            if (dateString.match(regEx) !== null) {
                return true; //var format = self.ddmmyy_to_utcdate(dateString);
                //return self.isValidYear(format);
            }
            return false;
        };

        this.isOrgnrValid = function (element, klarna) {
            var regEx = null;

            if (self.CustomerCountryId === 1) //Norge
                regEx = /^(\d{9})$|((\d{3})\s(\d{3})\s(\d{3}))$/;
            else if (self.CustomerCountryId === 2) //Sverige
                regEx = /^(\d{10})$|(\d{6}[-]\d{4})$/;

            if (regEx === null) return true;
            return regEx.test(element.val());
        };

        this.isBirthdateValid = function (element) {
            var isValid = false;
            var value = element.val();
            if (value.length > 0) {
                if (self.isValidDateddmmyy(value)) { //011299) 
                    isValid = true;
                }
            }

            return isValid;
        };

        this.selectFirstInList = function () {
            $("input:radio").filter(':visible:first').attr("checked", true);
        };

        this.GetCheckoutSnippet = function (paymentId, isPaymentChange) {
            if (paymentId === KCO_BETBETID || paymentId === NETS_EASY_BETBETID || paymentId === SCO_BETBETID) {
                self.GetCheckout(paymentId, isPaymentChange);
            } else if (paymentId === VIPPS_BETBETID && !self.isLoggedIn() && self.vippsExpressCheckoutInCart() && (!self.vippsAllowBusinessCustomer() || self.CustomerType() !== 'bedriftskunde')) {
                $("#customer-registration").hide();
            } else {
                $("#customer-registration").show();

                PubSub.publish(mcWeb.checkout.events.onShowSendOrder,
                    { showBtn: true, disabledBtn: false, showPrice: false });
            }
        };

        this.GetCheckout = function (paymentId, isPaymentChange) {
            $("#customer-registration").hide();
            $("#nets-easy-checkout-error").hide();
            $("#svea-checkout-error").hide();

            if (paymentId === SCO_BETBETID)
                self.disableSveaCheckout();

            if (self.cartGuid === null || self.cartName === null) {
                self.waitCheckoutSnippet = true;
                return;
            }
            self.waitCheckoutSnippet = false;

            PubSub.publish(mcWeb.checkout.events.onShowSendOrder,
                { showBtn: false, disabledBtn: false, showPrice: false });

            var customerData = this.registration.getJsonData();
            if (typeof (customerData.epost) !== "undefined") {
                if (customerData.epost.length > 0) customerData.epost = customerData.epost.trim();
            }

            if (!isPaymentChange)
                isPaymentChange = false;

            var data = { Customer: customerData, CartGuid: self.cartGuid, CartName: self.cartName, IsPaymentChange: isPaymentChange };

            if (paymentId === KCO_BETBETID) {
                self.service.PostAction("GetKlarnaCheckoutSnippet", data).then(function (result) {
                    if (result === null || result.length < 1) {
                        console.log("Kunne ikke laste Klarna Checkout");
                        return;
                    }

                    if (result.Success || !result.RedirectUrl) {
                        self.SetKlarnaCheckout(result.CheckoutSnippet);
                        return;
                    }

                    if (result.RedirectUrl) {
                        window.location.href = result.RedirectUrl;
                    }
                });
            }

            if (paymentId === NETS_EASY_BETBETID) {
                self.service.PostAction("GetNetsEasyCheckoutSnippet", data).then(function (result) {
                    if (result === null || result.length < 1) {
                        $("#nets-easy-checkout-error").show();
                        console.log("Kunne ikke laste Nets Easy Checkout");
                        return;
                    }
                    if (result.RedirectUrl) window.location = result.RedirectUrl;
                    self.SetNetsEasyCheckout(result.CheckoutOptions);
                });
            }

            if (paymentId === SCO_BETBETID) {
                self.service.PostAction("GetSveaCheckoutSnippet", data).then(function (result) {
                    if (result === undefined || result === null || result.length < 1) {
                        $("#svea-checkout-error").show();
                        console.log("Kunne ikke laste Svea Checkout");
                        self.enableSveaCheckout();
                        return;
                    }
                    self.SetSveaCheckout(result);
                    self.enableSveaCheckout();
                });
            }
        };

        this.disableSveaCheckout = function () {
            if (window.scoApi)
                window.scoApi.setCheckoutEnabled(false);
        }

        this.enableSveaCheckout = function () {
            if (window.scoApi)
                window.scoApi.setCheckoutEnabled(true);
        }

        this.SetSveaCheckout = function (snippet) {
            $("#svea-checkout-snippet").html(snippet);
            self.RegisterSveaCheckoutListener();
        };

        this.netsEasyCheckoutHtml = ko.observable();
        this.netsEasyCheckoutPaymentId = ko.observable();

        this.SetNetsEasyCheckout = function (checkoutOptions) {
            try {
                var checkoutSnippetHtml = $("#nets-easy-checkout-snippet").html();

                if (checkoutSnippetHtml !== undefined) {
                    if (!checkoutSnippetHtml || checkoutSnippetHtml.length == 0 || self.netsEasyCheckoutPaymentId() != checkoutOptions.paymentId) {
                        if (self.netsEasyCheckoutHtml() && self.netsEasyCheckoutHtml().length > 0 && self.netsEasyCheckoutPaymentId() == checkoutOptions.paymentId) {
                            $("#nets-easy-checkout-snippet").html(self.netsEasyCheckoutHtml());
                            $("#nets-easy-checkout-snippet").addClass("dibs-checkout-wrapper");
                        }
                        else {
                            console.log("Nets Easy, initializing!");

                            // Før vi kjører new og setter callbacks må vi rydde opp...
                            if (self.netsEasyCheckout) {
                                self.netsEasyCheckout.cleanup();
                                $("#nets-easy-checkout-snippet").html("");
                            }

                            self.netsEasyCheckout = new Dibs.Checkout(checkoutOptions);
                            self.RegisterNetsEasyCallback(self.netsEasyCheckout);
                            self.netsEasyCheckoutHtml($("#nets-easy-checkout-snippet").html());
                            self.netsEasyCheckoutPaymentId(checkoutOptions.paymentId);
                        }
                    }
                }
            } catch (e) {
                console.log('Warning - PaymentView.js:SetNetsEasyCheckout. Exception: ' + e);
            }
        };

        this.RegisterNetsEasyCallback = function (checkout) {
            checkout.on('payment-completed', function (response) {
                var redirectMsg = $('#nets-easy-process-checkout').html();
                self.showTemplate(redirectMsg);
                PubSub.publish(mcWeb.lightbox.events.onShowLightbox, { backdrop: 'static', keyboard: false, show: true });

                var data = { paymentId: response.paymentId };
                self.service.GetAction("NetsEasyCheckoutComplete", data).then(function (result) {
                    if (result === null || result.length < 1) {
                        console.log("Nets Easy, verifisering og opprettelse av ordre feilet eller ordre eksisterer");
                        PubSub.publish(mcWeb.lightbox.events.onHideLightbox);
                        return;
                    }
                    window.location = result;
                });
            });

            // Ved endring av postnummer i Nets Easy snippet oppdateres kassen...
            checkout.on('address-changed', function (address) { // Subscribe to address-changed event
                console.log("Nets Easy, address-changed");
                //console.log(address);

                if (address) {
                    var zipCode = "";
                    var countryCode = "";

                    if (address.postalCode !== null && address.postalCode.length > 1)
                        zipCode = address.postalCode;

                    if (address.countryCode !== null && address.countryCode.length > 1)
                        countryCode = address.countryCode;

                    if (zipCode !== "" && countryCode !== "") {
                        var data = { zipCode: zipCode, landKode3: countryCode };
                        PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                        self.UpdateCheckoutZipCode(zipCode);
                    }
                }

                var paymentAddress = { Provider: "NetsEasy", Name: "", Email: "", StreetAddress: "", StreetAddress2: "", PostalCode: address.postalCode, City: "", CountryCode: address.countryCode };
                self.service.PostAction("GetPaymentAddress", paymentAddress).then(function (result) {
                    self.SetPorterbuddyRecipientInfo("NetsEasy", result.Email, result.PostalCode, result.StreetAddress);
                });

                self.service.GetAction("NetsEasyIsCustomerPerson", null).then(function (result) {
                    if (result === null || result.length < 1) {
                        return;
                    }

                    var customerType = "";
                    if (result === true)
                        customerType = "person";
                    else
                        customerType = "organization";
                    console.log("Nets Easy, customerType = " + customerType);

                    var defaultCustomerType = 'person';
                    if (self.KlarnaCustomerType() === 'bedriftskunde')
                        defaultCustomerType = 'organization';
                    if (customerType !== defaultCustomerType)
                        self.showPaymentProviderCartReloadLightbox(customerType);
                });
            });

            // whenever the consumer clicks on the "pay" button
            checkout.on('pay-initialized', function (response) {
                var success = true;
                checkout.send('payment-order-finalized', success);
            });
        };

        this.SetKlarnaCheckout = function (snippet) {
            $("#klarna-checkout-snippet").html(snippet);
            self.RegisterKlarnaListener();
        };

        this.SuspendKlarnaCheckout = function () {
            try {
                if (typeof (window._klarnaCheckout) !== "undefined") {
                    window._klarnaCheckout(function (api) {
                        api.suspend();
                    });
                }
            } catch (e) {
                console.log('Warning - PaymentView.js:SuspendKlarnaCheckout. Exception: ' + e);
            }
        };

        this.ResumeKlarnaCheckout = function () {
            try {
                if (typeof (window._klarnaCheckout) !== "undefined") {
                    window._klarnaCheckout(function (api) {
                        api.resume();
                    });
                }
            } catch (e) {
                console.log('Warning - PaymentView.js:ResumeKlarnaCheckout. Exception: ' + e);
            }
        };

        PubSub.subscribe(mcWeb.payments.events.onShowUpdateIcon, function (message, data) {
            self.showRefreshSpin(true);
        });

        PubSub.subscribe(mcWeb.payments.events.onHideUpdateIcon, function (message, data) {
            self.showRefreshSpin(false);
        });

        this.IsKcoEnabled = function () {
            try {
                if (self.PaymentTypes() === null)
                    return false;
                var kcoEnabled = false;

                for (var i = 0; i < self.PaymentTypes().length; i++) {
                    if (self.PaymentTypes()[i].PaymentId === KCO_BETBETID) {
                        kcoEnabled = true;
                    }
                }

                return kcoEnabled;
            } catch (e) {
                console.log('Warning - PaymentView.js:kcoEnabled. Exception: ' + e);
                return false;
            }
        };

        // Oppdaterer KCO/EASY desom postnummer endres i kassen
        this.UpdateCheckoutZipCode = function (zipCode) {
            try {
                var paymentId = self.selectedPayment();
                if (paymentId === undefined) return;

                if (paymentId === KCO_BETBETID) {
                    if (!self.klarnaShippingAssistantEnabled()) return;
                    var isKcoEnabled = self.IsKcoEnabled();
                    if (!isKcoEnabled) return;
                    self.SuspendKlarnaCheckout();
                }

                if (paymentId === NETS_EASY_BETBETID) {
                    if (self.netsEasyCheckout && !self.netsEasyFrozen()) {
                        self.netsEasyCheckout.freezeCheckout();
                        self.netsEasyFrozen(true);
                    }
                    self.netsEasyFreezeStack.push("UpdateCheckoutZipCode");
                }

                var data = { paymentId: paymentId, zipCode: zipCode };
                self.service.GetAction("UpdateCheckoutZipCode", data).then(function (result) {
                    if (paymentId === KCO_BETBETID)
                        self.ResumeKlarnaCheckout();

                    if (paymentId === NETS_EASY_BETBETID) {
                        self.netsEasyFreezeStack.pop();

                        if (self.netsEasyCheckout && self.netsEasyFreezeStack.length === 0 && self.netsEasyFrozen()) {
                            self.netsEasyCheckout.thawCheckout();
                            self.netsEasyFrozen(false);
                        }
                    }
                });
            } catch (e) {
                console.log('Warning - PaymentView.js:UpdateCheckoutZipCode. Exception: ' + e);
            }
        };

        this.netsEasyFreezeStack = [];
        this.netsEasyFrozen = ko.observable(false);

        this.UpdateCheckoutCartItems = function () {
            if (self.selectedPayment() !== KCO_BETBETID && self.selectedPayment() !== NETS_EASY_BETBETID && self.selectedPayment() !== SCO_BETBETID) {
                return;
            }

            if (self.selectedPayment() === KCO_BETBETID) {
                $("#klarna-checkout-snippet-error").hide();
                self.SuspendKlarnaCheckout();  // Vi trenger denne for at KCO-snippet skal oppdateres med korrekte priser (BUG: Mobil scroll to buttom)

                self.service.GetAction("UpdateKlarnaCheckoutCartItems", null).then(function (result) {
                    self.ResumeKlarnaCheckout();  // Vi trenger denne for at KCO-snippet skal oppdateres med korrekte priser (BUG: Mobil scroll to buttom)

                    if (result === null || result.length < 1) {
                        console.log("UpdateKlarnaCheckoutCartItems failed...");
                        return;
                    }

                    if (!result.Success) {
                        if (result.Payload) {
                            window.location.href = result.Payload;
                        }

                        $("#klarna-checkout-snippet").hide();
                        $("#klarna-checkout-snippet-error").show();
                    }

                    $("#klarna-checkout-snippet").show();
                    $("#klarna-checkout-snippet-error").hide();
                });
            }

            if (self.selectedPayment() === NETS_EASY_BETBETID) {
                if (self.netsEasyCheckout && !self.netsEasyFrozen()) {
                    self.netsEasyCheckout.freezeCheckout();
                    self.netsEasyFrozen(true);
                }
                self.netsEasyFreezeStack.push("UpdateNetsEasyCheckoutCartItems");

                self.service.GetAction("UpdateNetsEasyCheckoutCartItems", null).then(function (result) {
                    self.netsEasyFreezeStack.pop();

                    if (self.netsEasyCheckout && self.netsEasyFreezeStack.length === 0 && self.netsEasyFrozen()) {
                        self.netsEasyCheckout.thawCheckout();
                        self.netsEasyFrozen(false);
                    }

                    if (result === null || result.length < 1) {
                        console.log("UpdateNetsEasyCheckoutCartItems failed...");
                        return;
                    }
                });
            }

            if (self.selectedPayment() === SCO_BETBETID) {
                self.disableSveaCheckout();

                self.service.GetAction("UpdateSveaCheckoutCartItems", null).then(function (result) {
                    if (result === null || result.length < 1)
                        console.log("UpdateSveaCheckoutCartItems failed");
                    else if (result == 'true')
                        console.log("Update OK");
                    else if (result == 'false')
                        console.log("Empty snippet");
                    else
                        console.log(result);

                    self.enableSveaCheckout();
                });
                return;
            }
        };

        this.showKcoCartReloadLightbox = function (customerType) {
            if (self.klarnaShowChangedCustomerTypeMessage()) {
                // Ved endring av kundetype i KCO-snippet må vi laste kassen på nytt.
                self.showTemplate($('#kco-reload-cart').html());
                PubSub.publish(mcWeb.lightbox.events.onShowLightbox, { backdrop: 'static', keyboard: false, show: true });

                document.getElementById("kco-reload-cart-btn").addEventListener("click", function () {
                    self.changeCustomerType(customerType);
                });
            } else {
                self.changeCustomerType(customerType);
            }
        };

        this.changeCustomerType = function (customerType) {
            if (customerType === 'organization') {
                PubSub.publish(mcWeb.events.customerRegistration.onChangedCustomerType, 1);
            } else {
                PubSub.publish(mcWeb.events.customerRegistration.onChangedCustomerType, 0);
            }
        }

        this.showPaymentProviderCartReloadLightbox = function (customerType) {
            // Ved endring av kundetype må vi laste kassen på nytt.

            self.showTemplate($('#payment-provider-reload-cart').html());
            PubSub.publish(mcWeb.lightbox.events.onShowLightbox, { backdrop: 'static', keyboard: false, show: true });

            document.getElementById("payment-provider-reload-cart-btn").addEventListener("click", function () {
                if (customerType === 'organization')
                    PubSub.publish(mcWeb.events.customerRegistration.onChangedCustomerType, 1);
                else
                    PubSub.publish(mcWeb.events.customerRegistration.onChangedCustomerType, 0);
            });
        };

        this.clickBusiness = function () {
            self.registration.registrationVM.showCustomerType(false);
            self.registration.registrationVM.showRegButtons(true);
            PubSub.publish(mcWeb.events.customerRegistration.onChangedCustomerType, 1)
        }

        this.clickPrivate = function () {
            self.registration.registrationVM.showCustomerType(false);
            self.registration.registrationVM.showRegButtons(true);
            PubSub.publish(mcWeb.events.customerRegistration.onChangedCustomerType, 0)
        }

        this.VippsExpressCheckout = function () {
            var checkoutFooter = mcWeb.checkoutFooterView.instances['footer'];
            var okToContinue = checkoutFooter.insertOrder('vipps');

            if (okToContinue) {
                var url = "/api/vipps/express-checkout?checkout=true";

                //var useExpressCheckout = true;
                //if (useExpressCheckout) {
                //    url = "/api/vipps/express-checkout?checkout=true";
                //} else {
                //    url = "/api/vipps/register";
                //}

                $.ajax({
                    type: "GET",
                    url: url,
                    contentType: "application/json; charset=utf-8",
                    success: function (data) {
                        if (data) {
                            console.log("Vipps Success: " + data);
                            window.location.replace(data);
                        }
                        else {
                            console.log("Vipps: Blank URL");
                            self.langService.getValue("CheckoutReturnCodes", "VippsInitFailed").then(function (value) {
                                self.showErrorMessage(value);
                            });
                        }
                    },
                    error: function () {
                        console.log("Vipps Error");
                        self.langService.getValue("CheckoutReturnCodes", "VippsInitFailed").then(function (value) {
                            self.showErrorMessage(value);
                        });
                    }
                });
            }

            return;
        };

        this.RegisterSveaCheckoutListener = function () {
            try {
                logPb("RegisterSveaCheckoutListener()");

                document.addEventListener("checkoutReady", function () {
                    logPb("document.addEventListener(\"checkoutReady\")");

                    if (!window.scoApi.customEventHandlers["identity.phoneNumber"] || window.scoApi.customEventHandlers["identity.phoneNumber"].length === 0) {
                        logPb("Register window.scoApi.observeEvent(\"identity.phoneNumber\")");

                        window.scoApi.observeEvent("identity.phoneNumber", function (data) {
                            logPb("window.scoApi.observeEvent(\"identity.phoneNumber\")", data);
                        });
                    }
                    if (!window.scoApi.customEventHandlers["identity.firstName"] || window.scoApi.customEventHandlers["identity.firstName"].length === 0) {
                        logPb("Register window.scoApi.observeEvent(\"identity.firstName\")");

                        window.scoApi.observeEvent("identity.firstName", function (data) {
                            logPb("window.scoApi.observeEvent(\"identity.firstName\")", data);
                        });
                    }
                    if (!window.scoApi.customEventHandlers["identity.lastName"] || window.scoApi.customEventHandlers["identity.lastName"].length === 0) {
                        logPb("Register window.scoApi.observeEvent(\"identity.lastName\")");

                        window.scoApi.observeEvent("identity.lastName", function (data) {
                            logPb("window.scoApi.observeEvent(\"identity.lastName\")", data);
                        });
                    }

                    if (!window.scoApi.customEventHandlers["identity.postalCode"] || window.scoApi.customEventHandlers["identity.postalCode"].length === 0) {
                        logPb("Register window.scoApi.observeEvent(\"identity.postalCode\")");

                        window.scoApi.observeEvent("identity.postalCode", function (data) {
                            logPb("window.scoApi.observeEvent(\"identity.postalCode\")", data);

                            var postalCode = data.value;
                            if (!postalCode)
                                postalCode = "";

                            if (postalCode.length > 1) {
                                var data = { zipCode: postalCode };
                                PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                            }

                            var paymentAddress = { Provider: "Svea", Name: "", Email: "", StreetAddress: "", StreetAddress2: "", PostalCode: postalCode, City: "", CountryCode: "" };
                            self.service.PostAction("GetPaymentAddress", paymentAddress).then(function (result) {
                                logPb("GetPaymentAddress [identity.postalCode]", result);
                                self.SetPorterbuddyRecipientInfo("Svea", result.Email, result.PostalCode, result.StreetAddress);
                            });
                        });
                    }
                    if (!window.scoApi.customEventHandlers["identity.streetAddress"] || window.scoApi.customEventHandlers["identity.streetAddress"].length === 0) {
                        logPb("Register window.scoApi.observeEvent(\"identity.streetAddress\")");

                        window.scoApi.observeEvent("identity.streetAddress", function (data) {
                            logPb("window.scoApi.observeEvent(\"identity.streetAddress\")", data);

                            var streetAddress = data.value;
                            if (!streetAddress)
                                streetAddress = "";

                            var paymentAddress = { Provider: "Svea", Name: "", Email: "", StreetAddress: streetAddress, StreetAddress2: "", PostalCode: "", City: "", CountryCode: "" };
                            self.service.PostAction("GetPaymentAddress", paymentAddress).then(function (result) {
                                logPb("GetPaymentAddress [identity.streetAddress]", result);
                                self.SetPorterbuddyRecipientInfo("Svea", result.Email, result.PostalCode, result.StreetAddress);
                            });
                        });
                    }
                    if (!window.scoApi.customEventHandlers["identity.email"] || window.scoApi.customEventHandlers["identity.email"].length === 0) {
                        logPb("Register window.scoApi.observeEvent(\"identity.email\")");

                        window.scoApi.observeEvent("identity.email", function (data) {
                            logPb("window.scoApi.observeEvent(\"identity.email\")", data);

                            var email = data.value;
                            if (!email)
                                email = "";

                            var paymentAddress = { Provider: "Svea", Name: "", Email: email, StreetAddress: "", StreetAddress2: "", PostalCode: "", City: "", CountryCode: "" };
                            self.service.PostAction("GetPaymentAddress", paymentAddress).then(function (result) {
                                logPb("GetPaymentAddress [identity.email]", result);
                                self.SetPorterbuddyRecipientInfo("Svea", result.Email, result.PostalCode, result.StreetAddress);
                            });
                        });
                    }
                    if (!window.scoApi.customEventHandlers["order.validationCallback"] || window.scoApi.customEventHandlers["order.validationCallback"].length === 0) {
                        logPb("Register window.scoApi.observeEvent(\"order.validationCallback\")");

                        window.scoApi.observeEvent("order.validationCallback", async function (data) {
                            logPb("window.scoApi.observeEvent(\"order.validationCallback\")", data);

                            var valid = true;
                            result = await ValidateSveaTransaction();
                            if (result && result.length > 0) {
                                valid = false;
                                self.showErrorMessage(result);
                            }

                            data.callback({ valid: valid });
                        });
                    }
                });
            } catch (e) {
                logPb("Warning - PaymentView.js:RegisterSveaCheckoutListener. Exception", e.toString());
                console.log('Warning - PaymentView.js:RegisterSveaCheckoutListener. Exception: ' + e);
            }
        };

        self.previousPbEmail = "";
        self.previousPbPostCode = "";
        self.previousPbStreetAddress = "";

        async function ValidateSveaTransaction() {
            var validateResult = "";

            await self.service.GetAction("SveaCheckoutClientSideValidation", null).then(function (result) {
                validateResult = result;
            });

            return validateResult;
        }

        function shippingOptionsHandled(shippingOptions) {
            logPb("shippingOptionsHandled()", { shippingOptions });

            porterbuddy.homeDeliveryOptions = shippingOptions.homeDeliveryOptions;
            porterbuddy.refreshShippingOptions();
        }

        this.SetPorterbuddyRecipientInfo = function (provider, email, postCode, streetAddress) {
            if (!self.Porterbuddy)
                return;

            try {
                if (postCode.includes("•"))
                    postCode = "";

                if (typeof porterbuddy !== 'undefined' && porterbuddy.setRecipientInfo !== undefined &&
                    (email !== self.previousPbEmail || postCode !== self.previousPbPostCode || streetAddress !== self.previousPbStreetAddress)) {

                    if (!email) {
                        email = localStorage.getItem("pb-recipient-email");

                        if (!email)
                            email = "";
                    }

                    if (!postCode) {
                        postCode = localStorage.getItem("postalCode")

                        if (!postCode)
                            postCode = "";
                    }

                    if (!streetAddress) {
                        streetAddress = localStorage.getItem("pb-recipient-street-address");

                        if (!streetAddress)
                            streetAddress = "";
                    }

                    var paymentAddress = {
                        Provider: provider,
                        Name: "",
                        Email: email,
                        StreetAddress: streetAddress,
                        StreetAddress2: "",
                        PostalCode: postCode,
                        City: "",
                        CountryCode: ""
                    };
                    self.service.PostAction("GetPaymentAddress", paymentAddress).then(function (result) {
                        email = result.Email;
                        postCode = result.PostalCode;
                        streetAddress = result.StreetAddress;
                    });

                    self.previousPbEmail = email;
                    self.previousPbPostCode = postCode;
                    self.previousPbStreetAddress = streetAddress;

                    var recipientInfo = { email, postCode, streetAddress };

                    logPb("SetPorterbuddyRecipientInfo(): porterbuddy.setRecipientInfo()", { email, postCode, streetAddress });
                    porterbuddy.setRecipientInfo(recipientInfo);

                    savePbRecipientToLocalStorage(recipientInfo);

                    var shippingOptions = getShippingOptions(recipientInfo);
                    shippingOptions.then(shippingOptionsHandled);

                } else {
                    var pb = typeof porterbuddy !== 'undefined';
                    var sri = false;

                    if (pb) {
                        sri = porterbuddy.setRecipientInfo !== undefined;
                        if (!sri) porterbuddy.refresh();
                    }

                    var data = { Porterbuddy: pb, SetRecipientInfo: sri, Email: email, PostCode: postCode, StreetAddress: streetAddress, PreviousEmail: self.previousPbEmail, PreviousPostCode: self.previousPbPostCode, PreviousStreetAddress: self.previousPbStreetAddress };
                    logPb("SetPorterbuddyRecipientInfo(): Recipient already set or unavailable", data);
                }
            } catch (e) {
                logPb("SetPorterbuddyRecipientInfo(): exception", e.toString());
                console.log('Warning - PaymentView.js:SetPorterbuddyRecipientInfo. Exception: ' + e);
            }
        }

        function savePbRecipientToLocalStorage(recipient) {
            logPb("savePbRecipientToLocalStorage()", recipient);

            localStorage.setItem("pb-recipient-email", recipient.email);
            localStorage.setItem("postalCode", recipient.postCode);
            localStorage.setItem("pb-recipient-street-address", recipient.streetAddress);
        }

        function logPb(logTxt, logData) {
            try {
                var data = { Text: logTxt, Data: JSON.stringify(logData) };
                var cartService = new WebApiService("Cart");
                cartService.PostAction("LogPb", data);
            } catch (e) {
                console.log('Warning - PaymentView.js:logPb Exception: ' + e);
            }
        }

        this.RegisterKlarnaListener = function () {
            try {
                if (self.selectedPayment() !== KCO_BETBETID) return;

                if (typeof (window._klarnaCheckout) !== "undefined") {
                    window._klarnaCheckout(function (api) {
                        //console.log("RegisterKlarnaListener 'change'");

                        api.on({
                            'load': function (data) {
                                var customerType = data.customer.type;
                                var defaultCustomerType = 'person';
                                if (self.KlarnaCustomerType() === 'bedriftskunde')
                                    defaultCustomerType = 'organization';

                                if (customerType !== undefined) {
                                    if (customerType !== defaultCustomerType)
                                        self.showKcoCartReloadLightbox(customerType);
                                }
                            }
                        });

                        api.on({
                            'customer': function (data) {
                                var customerType = data.type;
                                var defaultCustomerType = 'person';
                                if (self.KlarnaCustomerType() === 'bedriftskunde')
                                    defaultCustomerType = 'organization';

                                if (customerType !== undefined) {
                                    if (customerType !== defaultCustomerType)
                                        self.showKcoCartReloadLightbox(customerType);
                                }
                            }
                        });

                        api.on({
                            'change': function (data) {
                                var kcoData = data;

                                if (data !== null && data.email !== null && typeof (data.email) !== "undefined" && data.email.length > 3) {
                                    PubSub.publish(mcWeb.loginCheckout.events.onChangedEmail, data.email);
                                }

                                if (data !== null && data.postal_code !== null && data.postal_code.length > 1) {
                                    if (data.postal_code.indexOf('*') === -1) {
                                        var zipCode = data.postal_code;
                                        var data = { zipCode: zipCode };
                                        PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                                    } else {
                                        data.postal_code = "";
                                    }
                                }

                                var email = "";
                                if (data.email)
                                    email = data.email;

                                var name = undefined;
                                if (kcoData.give_name)
                                    name = kcoData.give_name;
                                if (kcoData.family_name) {
                                    if (name)
                                        name = " " + kcoData.family_name;
                                    else
                                        name = kcoData.family_name;
                                }

                                var paymentAddress = { Provider: "KlarnaCheckout", Name: name, Email: kcoData.email, StreetAddress: "", StreetAddress2: "", PostalCode: kcoData.postal_code, City: kcoData.city, CountryCode: kcoData.country };
                                self.service.PostAction("GetPaymentAddress", paymentAddress).then(function (result) {
                                    self.SetPorterbuddyRecipientInfo("KlarnaCheckout", result.Email, result.PostalCode, result.StreetAddress);
                                });
                            }
                        });
                    });

                    if (self.klarnaShippingAssistantEnabled()) {
                        window._klarnaCheckout(function (api) {
                            api.on({
                                'shipping_option_change': function (data) {
                                    var jsonData = JSON.stringify(data)
                                    console.log("shipping_option_change: " + jsonData);

                                    var data = {
                                        shippingId: data.id,
                                        name: data.name,
                                        price: data.price,
                                        taxRate: data.tax_rate,
                                        taxAmount: data.tax_amount
                                    };

                                    var shipmentService = new WebApiService("Shipment");
                                    shipmentService.GetAction("SaveSelectedKlarnaCarrier", data).then(function (result) {
                                        PubSub.publish(mcWeb.cart.events.onChangedCart, "");
                                        //PubSub.publish(mcWeb.shipment.events.onSelectedShipment, carrier);
                                    });
                                }
                            });
                        });
                    }

                    if (self.kcoValidateCountry) {
                        window._klarnaCheckout(function (api) {
                            //console.log("RegisterKlarnaListener 'billing_address_change'");

                            api.on({
                                'billing_address_change': function (data) {
                                    var selectedCountry = data.country;
                                    var email = data.email;
                                    if (!email) email = "";

                                    var name = undefined;
                                    if (data.give_name)
                                        name = data.give_name;
                                    if (data.family_name) {
                                        if (name)
                                            name = " " + data.family_name;
                                        else
                                            name = data.family_name;
                                    }

                                    if (data !== null && data.postal_code !== null && data.postal_code.length > 1) {
                                        if (data.postal_code.indexOf('*') === -1) {
                                            var zipCode = data.postal_code;
                                            var data = { zipCode: zipCode };
                                            PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                                        } 
                                    }

                                    var paymentAddress = { Provider: "KlarnaCheckout", Name: name, Email: data.email, StreetAddress: "", StreetAddress2: "", PostalCode: data.postal_code, City: data.city, CountryCode: data.country };
                                    self.service.PostAction("GetPaymentAddress", paymentAddress).then(function (result) {
                                        self.SetPorterbuddyRecipientInfo("KlarnaCheckout", result.Email, result.PostalCode, result.StreetAddress);
                                    });

                                    if (!email) return;

                                    if (email) {
                                        self.service.GetAction("GetCustomerCountryCode3", { email: email }).then(function (result) {
                                            if (result) {
                                                var countryCode = result.m_Item1;
                                                var countryText = result.m_Item2;

                                                if (countryCode && countryCode !== selectedCountry) {
                                                    //console.log("Kunden har avvikende land: (" + countryCode + "/" + countryText + ") -> " + selectedCountry);

                                                    self.langService.getValue("CheckoutReturnCodes", "CountryCodeMismatch").then(function (value) {
                                                        if (value.length <= 0)
                                                            value =
                                                                'Det eksisterer allerede en kunde med denne epostadressen som er registrert i {COUNTRY}. For å fortsette med denne E-postadressen må land endres til {COUNTRY}. Alternativt kan en annen E-postadresse benyttes.';
                                                        value = value.replace(/{COUNTRY}/gi, countryText);
                                                        self.showErrorMessage(value);
                                                    });
                                                }
                                            }
                                        });
                                    }
                                }
                            });
                        });
                    }
                }
            } catch (e) {
                console.log('Warning - PaymentView.js:RegisterKlarnaListener. window._klarnaCheckout Exception: ' + e);
            }
        };

        self.showErrorMessage = function (message) {
            if (message.length > 0)
                self.showAlertErrorMessage(message);
        };

        self.showAlertErrorMessage = function (message, asHtml) {
            $("#lightbox-placeholder").html('');

            if (asHtml === true) {
                $("#error-message-label").append(message);
            } else {
                $("#error-message-label").html(message);
            }

            self.showTemplate($("#popup-error-message").html());
            PubSub.publish(mcWeb.lightbox.events.onShowLightbox, { show: true });
        };

        self.showTemplate = function (html) {
            var template = $("#lightbox-placeholder");
            if (template.length < 1) {
                PubSub.publish(mcWeb.checkout.events.onShowSendOrder, { showBtn: false, disabledBtn: false });
                return;
            }

            template.html(html);
        };

        this.zipCodePrev = ko.observable();
        this.zipCode = ko.observable();

        this.showOrgnrSsn = function (paymentId) {
            var data = { paymentId: paymentId };

            if (!(self.registration.registrationVM.readOnly() === true && self.registration.registrationVM.hideOrgnrSsn())) {
                self.service.GetAction("ShowOrgnrSsn", data).then(function (result) {
                    if (result.Show === true && result.FieldToShow !== 0) {
                        self.ShowOrgnrSsn(result.Show);
                        self.ShowOrgnrSsnField(result.FieldToShow);
                        self.CustomerType(result.CustomerType);
                    } else {
                        self.ShowOrgnrSsn(false);
                    }
                });
            } else {
                self.ShowOrgnrSsn(false);
            }
        };

        getLibrary("mcWeb.customerRegistration").then(() => {
            PubSub.subscribe(mcWeb.events.customerRegistration.onChangedZipCode, function (message, data) {
                if (!data)
                    return;

                var zipCode = data.zipCode;
                if (!zipCode)
                    return;

                if (self.zipCode() !== zipCode) {
                    self.zipCodePrev(zipCode);
                    self.zipCode(zipCode);
                    self.UpdateCheckoutZipCode(zipCode);
                }
            });            
        });

        PubSub.subscribe(mcWeb.payments.events.updateKco, function (message, data) {
            self.UpdateCheckoutCartItems();
        });

        getLibrary("mcWeb.campaignCode").then(() => {
            PubSub.subscribe(mcWeb.campaignCode.onChangedCampaignCode, function (message, data) {
                self.UpdateCheckoutCartItems();
                PubSub.publish(mcWeb.payments.events.reloadPayments, null);
            });
        });

        PubSub.subscribe(mcWeb.cart.events.onChangedCart, function (message, data) {
            self.UpdateCheckoutCartItems();
        });

        PubSub.subscribe(mcWeb.cart.events.onChangedQuantityCart, function (message, data) {
            self.UpdateCheckoutCartItems();
            PubSub.publish(mcWeb.payments.events.reloadPayments, { parentEvent: mcWeb.cart.events.onChangedQuantityCart });
        });

        PubSub.subscribe(mcWeb.shipment.events.onSelectedShipment, function (message, data) {
            PubSub.publish(mcWeb.cart.events.onChangedCart, null);
        });

        PubSub.subscribe(mcWeb.shipment.events.onChangedShipment, function (message, data) {
            self.UpdateCheckoutCartItems();
        });

        PubSub.subscribe(mcWeb.payments.events.reloadPayments, function (message, data) {
            if (data) return;

            mcWeb.loginCheckout.ResetLoginCheckoutPosision();
            if (!self.isPublishMode) {
                $("#mcweb-customerregistration-checkout-registration").hide().detach().appendTo("body");
            }
            self.load(null, null, data === undefined || data === null || data.parentEvent !== mcwe.car.events.onChangedQuantityCart);
        });

        PubSub.subscribe(mcWeb.payments.events.focusFirstName, function (message, data) {

            if (mcWeb.responsive.getScreenSize() !== 'xs') {
                setTimeout(function () {

                    if (self.ShowOrgnrSsn()) {
                        switch (self.ShowOrgnrSsnField()) {
                            case 1:
                                $("div[id=" + self.selectedPayment() + "]").find("input[class*='genericOrgnr']").focus();
                                break;
                            case 2:
                                $("div[id=" + self.selectedPayment() + "]").find("input[class*='genericSsn']").focus();
                                break;
                            case 3:
                                $("div[id=" + self.selectedPayment() + "]").find("input[class*='genericBirthdate']").focus();
                                break;
                        }

                    } else {
                        $("#firstName").focus();
                    }

                }, 400);
            }

        });

        PubSub.subscribe(mcWeb.login.events.onIsloggedIn, function (message, isLoggedIn) {
            self.isLoggedIn(isLoggedIn);
        });

        PubSub.subscribe(mcWeb.payments.events.processPaymentMethods, function (message, paymentId) {
            self.processPaymentMethods(paymentId);
        });

        this.processPaymentMethods = function (paymentId, isPaymentChange) {
            if (paymentId === null) {
                paymentId = self.selectedPayment();
                return;
            }

            self.showOrgnrSsn(paymentId);
            self.GetCheckoutSnippet(paymentId, isPaymentChange);

            // Vipps er ikke tilgjengelig for bedriftskunder
            if (paymentId === VIPPS_BETBETID && self.vippsExpressCheckoutInCart() && (!self.vippsAllowBusinessCustomer() || self.CustomerType() !== 'bedriftskunde'))
                self.clickPrivate();
        };

        PubSub.subscribe(mcWeb.payments.events.updateOrgNr, function (message, data) {
            self.Orgnr(data);
            PubSub.publish(mcWeb.events.customerRegistration.updateOrgNr, data);
        });

        PubSub.subscribe(mcWeb.cart.events.cartGuid, function (message, data) {
            if (data !== null) {
                self.cartName = data.cartName;
                self.cartGuid = data.cartGuid;

                if (self.cartGuid !== null && self.cartName !== null) {
                    if (self.waitCheckoutSnippet === true) {
                        self.GetCheckoutSnippet(self.selectedPayment());
                    }
                }
            }
        });

        this.validate = function () {
            var promise = vm.validateModel().then(function (res) {
                var result = {
                    success: false,
                    message: '',
                    invalidElements: []
                };

                vm.lastValidationResult = res;

                if (res.every(mcWeb.validation.elementIsValid)) {
                    if (vm.settings.SoftAdressValidation && !vm.adress() && vm.addressWarningFlag === 0) {
                        result.message = "Adresse feltet er tomt.<br/> Fortsett med registrering om du ikke har gateadresse!";
                        vm.addressWarningFlag = 1;
                        //} else if (vm.settings.AllowNewPostNr && vm.cityDoesNotMatch && vm.zipcodeWarningFlag == 0) {
                        //	result.message = "Du har oppgitt et nytt postnr og poststed.<br/>Fortsett med registrering om du mener dette er riktig!";
                        //	vm.zipcodeWarningFlag = 1;
                    } else {
                        result.success = true;
                    }
                } else {
                    res.forEach(function (validationResult) {
                        if (!validationResult.valid)
                            result.invalidElements.push(validationResult);
                    });

                    result.message = $('#validation-error-text').html();
                }

                return result;
            });

            return promise;
        };

        this.validateModel = function () {
            $('.qtip').remove();
            var index;
            var res = mcWeb.validation.validateModel(vm.validationRules);
            return res.then(function (res) {
                for (index = 0; index < res.length; index++) {
                    if (res[index].valid) {
                        mcWeb.validation.setValidCss(res[index].elem);
                        continue;
                    } else {
                        mcWeb.validation.removeValidCss(res[index].elem);
                        mcWeb.validation.addErrorClass(res[index].elem);
                        mcWeb.validation.qTipActionShow(res[index].elem, vm.getErrorMessage(res[index].elem, res[index].rule));
                        break;
                    }
                }

                return res;
            });
        };

        this.validateElement = function (eledata, event) {
            mcWeb.validation.validateElement(vm.validationRules, event.target)
                .then(function (elemValidationResult) {
                    if (elemValidationResult.valid) {
                        mcWeb.validation.setValidCss(event.target);
                    } else {
                        mcWeb.validation.removeValidCss(event.target);
                    };
                });
        };
    };
});